import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  // allow overriding Paper sx for larger dialogs
  paperSx?: any;
  showCloseIcon?: boolean;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  paperSx,
  showCloseIcon = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(15, 23, 42, 0.45)",
            backdropFilter: "blur(3px)",
          },
        },
      }}
      PaperProps={{
        sx: {
          "@keyframes customDialogIn": {
            from: { opacity: 0, transform: "scale(0.96) translateY(8px)" },
            to: { opacity: 1, transform: "none" },
          },
          animation: "customDialogIn 240ms cubic-bezier(0.2, 0, 0, 1)",
          borderRadius: 4,
          boxShadow: 8,
          p: 2,
          minWidth: { xs: "90vw", sm: 400 },
          maxWidth: 500,
          bgcolor: "background.paper",
          ...(paperSx || {}),
        },
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: "1.35rem",
            color: "primary.main",
            pb: 1,
            pr: 5,
            position: "relative",
          }}
        >
          {title}
          {showCloseIcon ? (
            <IconButton
              onClick={onClose}
              aria-label="Close"
              sx={{
                position: "absolute",
                right: 12,
                top: 10,
                color: "text.secondary",
              }}
            >
              <CloseIcon fontSize="medium" />
            </IconButton>
          ) : null}
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          px: 3,
          py: 2,
          bgcolor: "background.default",
          borderRadius: 2,
        }}
      >
        <Box sx={{ mt: 1 }}>{children}</Box>
      </DialogContent>
      {actions && (
        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomDialog;
